import * as React from 'react'
import { useRouterState } from '@tanstack/react-router'
import { callAction } from '@/api/client'
import { useCan } from '@/api/hooks'
import { featureOf } from './features'

/** Record a feature visit at most once per this interval per tab. */
const EVERY_MS = 10 * 60_000
const last = new Map<string, number>()

/** Test hook: forget what was recorded. */
export function resetPageTracking() {
  last.clear()
}

/** Should a visit of this feature be recorded now? (updates the memo) */
export function shouldTrack(feature: string | undefined, now = Date.now()): feature is string {
  if (!feature) return false
  const prev = last.get(feature)
  if (prev !== undefined && now - prev < EVERY_MS) return false
  last.set(feature, now)
  return true
}

/**
 * Tell the rollout plan which feature pages people open (rollout.track: one counter per person,
 * feature and day), so «Впровадження» can show who uses a feature and who does not.
 */
export function usePageTracking() {
  const can = useCan('rollout.track')
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  React.useEffect(() => {
    if (!can) return
    const feature = featureOf(pathname)
    if (!shouldTrack(feature)) return
    callAction('rollout.track', { feature }).catch(() => {
      /* usage tracking never disturbs the user */
    })
  }, [can, pathname])
}
